import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

export function useE55AcceptFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      try {
        const response = await axios.get(`/data-set/e55/accept`, {
          params: {
            dataSet: fileId
          }
        });
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          let errorMessage = 'Failed to accept file';

          if (axiosError.response?.data) {
            const data = axiosError.response.data as any;
            if (typeof data === 'string') {
              errorMessage = data;
            } else if (data.message) {
              errorMessage = data.message;
            } else if (data.error) {
              errorMessage = data.error;
            } else if (data.detail) {
              errorMessage = data.detail;
            } else if (data.errorMessage) {
              errorMessage = data.errorMessage;
            }
          } else if (axiosError.message) {
            errorMessage = axiosError.message;
          }

          throw new Error(errorMessage);
        }

        throw error as Error;
      }
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e55Samples'] });
      queryClient.invalidateQueries({ queryKey: ['e55FileDetails'] });
    }
  });
} 